import { render, staticRenderFns } from "./First_mobile.vue?vue&type=template&id=10a92230&scoped=true&"
import script from "./First_mobile.vue?vue&type=script&lang=js&"
export * from "./First_mobile.vue?vue&type=script&lang=js&"
import style0 from "./First_mobile.vue?vue&type=style&index=0&id=10a92230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a92230",
  null
  
)

export default component.exports